import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import FulfillmentInformation from 'components/Cart/FulfillmentInformation';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';
import { useIsGroupOrderGuestDiner } from 'bento-ordering/group_ordering/hooks/index';

const CartPickup = ({
  handleClick,
  fulfillmentTimeOrASAP,
  fulfillmentAddress
}) => {
  const isGroupOrderGuestDiner = useIsGroupOrderGuestDiner();

  return (
    <Box data-testid="fulfillment-information" width="100%" mb={2}>
      <Box mb={1.5}>
        <Box mr={2.5} display="inline">
          <FulfillmentInformation
            title="Pickup Time"
            info={fulfillmentTimeOrASAP}
            onClick={handleClick}
            dataTestId={'pickup-time'}
            disabled={isGroupOrderGuestDiner}
          />
        </Box>
        <FulfillmentInformation
          title="Pickup From"
          info={fulfillmentAddress}
          onClick={handleClick}
          dataTestId={'pickup-from'}
          disabled={isGroupOrderGuestDiner}
        />
      </Box>
      {!isGroupOrderGuestDiner && (
        <Box position="relative">
          <SecondaryCta
            handleClick={handleClick}
            dataTestId="cart-pickup"
            label="Change"
            ownState={getOwnCartDrawerState()}
          />
        </Box>
      )}
    </Box>
  );
};

CartPickup.propTypes = {
  handleClick: PropTypes.func,
  fulfillmentTimeOrASAP: PropTypes.string,
  fulfillmentAddress: PropTypes.string
};

export default CartPickup;
